// ja strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "オリジナルAIボイスをトレーニング | Jammable",
  "train.seo.description":
    "Jammableで自分だけのAIボイスをトレーニング。音声ファイルをアップロードしてボイスモデルを作成し、コミュニティに公開することも、非公開にすることもできます。",
  "train.h1": "ボイスをトレーニング",
  "train.sub":
    "クリアな歌声や話し声を数分入れるだけで、カバーに使える声のクローンができあがります。",
  "train.voicesTrained": "{count}ボイスがトレーニング済み",

  "train.faq.title": "よくある質問",
  "train.faq.dataset.q": "データセットとは？",
  "train.faq.dataset.a1": "ボーカルが入った音声ファイルのセットです。",
  "train.faq.dataset.a2":
    "歌声または話し声が{min}分以上（できれば10分以上）必要です。",
  "train.faq.dataset.a3": "MP3、WAV、M4A形式に対応しています。",
  "train.faq.private.q": "作ったボイスは非公開にできますか？",
  "train.faq.private.a":
    "はい！非公開にすれば、そのボイスモデルにアクセスしたり、見たり、使ったりできるのはあなただけです！",
  "train.faq.time.q": "トレーニングにはどのくらい時間がかかりますか？",
  "train.faq.time.a":
    "追加する音声の量によります。通常、10分の音声なら{short}、1時間の音声なら{long}です。ページを閉じても大丈夫です。完成したらメールでお知らせします。",

  // How long training takes (lib/train/eta minutesLabel, same rounding).
  "train.eta.minutes": "約{m}分",
  "train.eta.hour": "約{h}時間",
  "train.eta.hours": "約{h}時間",
  "train.eta.hourMinutes": "約{h}時間{m}分",
  "train.eta.hoursMinutes": "約{h}時間{m}分",
  "train.minutes": "{n}分",

  // Shared by both steps' summary cards
  "train.samples": "サンプル",
  "train.filesOne": "1ファイル · {time}",
  "train.filesMany": "{n}ファイル · {time}",
  "train.passesLeft": "残りのトレーニングパス",
  "train.unlimited": "無制限",
  "train.nameIt": "名前を付ける",
  "train.creatorShort": "トレーニングはCreatorプランに含まれます。",

  // Step 1: upload or record
  "train.upload.invalidType": "無効なファイル形式です。",
  "train.upload.skippedOne":
    "{names}はすでに追加済みのためスキップしました。同じ音声を2回入れてもボイスは良くならないため、1回分として数えます。",
  "train.upload.skippedMany":
    "{names}はすでに追加済みのためスキップしました。同じ音声を2回入れてもボイスは良くならないため、1回分として数えます。",
  "train.upload.nFiles": "{n}個のファイル",
  "train.upload.someInvalid": "無効なファイルが含まれています。",
  "train.upload.failed": "アップロードに失敗しました",
  "train.upload.needsPlan": "アップロードにはプランが必要です",
  "train.upload.tooManyLabel":
    "現在アップロードが集中しています。しばらくしてからお試しください",
  "train.upload.tooManyToast":
    "現在アップロードが集中しています。数分後にもう一度お試しください。",
  "train.upload.analysing":
    "ファイル内の無音部分を検出しています。少々お待ちください。",
  "train.upload.blocked":
    "ブロックされたファイルがあります。続けるには削除してください。",
  "train.upload.errored":
    "エラーのあるファイルがあります。続けるには削除してください。",
  "train.upload.processing":
    "処理中のファイルがあります。完了するまでお待ちください。",
  "train.upload.tooShort":
    "無音部分を除いて、歌声または話し声が{min}必要です。現在は{have}です。",
  "train.upload.tooLong":
    "音声は{max}までです。現在は{have}あるので、ファイルを削除するか一部をカットしてください。",
  "train.upload.title": "声を追加",
  "train.upload.ofMin": "/ {min}",
  "train.upload.overLimit": "上限の{n}分を{over}超えています",
  "train.upload.ready": "準備完了 ✓",
  "train.upload.addMore": "あと{left}追加",
  "train.upload.short":
    "ボイスは{n}分以上あるほうが良い仕上がりになります。今すぐトレーニングすることも、音声があればあと{left}追加することもできます。",
  "train.upload.uploadFiles": "ファイルをアップロード",
  "train.upload.record": "録音",
  "train.upload.addIt": "追加する",
  "train.upload.recordHint": "歌っても話してもOK。何回でも録音できます。",
  "train.upload.blockedFrom": "ブロック済み - {label}のコンテンツ",
  "train.upload.gettingReady": "準備中...",
  "train.upload.ofVoice": "声 {time}",
  "train.upload.removed": "{time}を除去",
  "train.upload.uploading": "アップロード中...",
  "train.upload.done": "完了",
  "train.upload.trim": "トリミング",
  "train.upload.retry": "再試行",
  "train.upload.remove": "{name}を削除",
  "train.upload.silenceNote":
    "無音部分は自動で除去されます。紫の部分がボイスの学習に使われます。",
  "train.upload.tip1.title": "声は1人だけ",
  "train.upload.tip1.sub": "バックコーラスや観客の声はなし",
  "train.upload.tip2.title": "静かな部屋で",
  "train.upload.tip2.sub": "反響や雑音のない環境",
  "train.upload.tip3.title": "多いほど良い",
  "train.upload.tip3.sub": "いろいろな音程や言葉を",
  "train.upload.nextHint": "次は名前、画像、公開範囲を決めます。",
  "train.upload.cardTitle": "あなたのサンプル",
  "train.upload.footnote":
    "歌声または話し声が{min}以上（{rec}以上がおすすめ）、最大{max}まで。無音部分と重複ファイルはカウントされません。無音部分は自動でカットされます。",
  "train.upload.footnoteNoRec":
    "歌声または話し声が{min}以上、最大{max}まで。無音部分と重複ファイルはカウントされません。無音部分は自動でカットされます。",
  "train.upload.creatorNote":
    "トレーニングはCreatorプランに含まれます。まずボーカルをアップロードして、最後に決めてください。お支払い前に料金が表示されます。",
  "train.upload.continue": "続ける",

  // A sample's play button and the trim editor
  "train.sample.play": "{label}を再生",
  "train.sample.pause": "{label}を一時停止",
  "train.clip.keptOf": "/ {total} を使用",
  "train.clip.silenceCut": "無音 {time} をカット",
  "train.clip.cutByYou": "手動で {time} をカット",
  "train.clip.cut": "カット",
  "train.clip.play": "再生",
  "train.clip.stop": "停止",
  "train.clip.keepIt": "残す",
  "train.clip.cutIt": "カットする",
  "train.clip.cancel": "キャンセル",
  "train.clip.hint":
    "不要な部分をドラッグで選んでカットします。タップすると試聴できます。",
  "train.clip.undo": "カットを元に戻す",

  // Step 2: name, picture, settings, start
  "train.info.samplesAdded": "追加したサンプル",
  "train.info.edit": "編集",
  "train.info.namePlaceholder": "ボイス名（例：私の声）",
  "train.info.descPlaceholder":
    "説明 - ボイスのトレーニング方法などをコミュニティに紹介しましょう...",
  "train.info.whoCanUse": "公開範囲",
  "train.info.private": "非公開（自分のみ）",
  "train.info.public": "ライブラリで公開",
  "train.info.cleanUp": "サンプルをクリーンアップ",
  "train.info.removeInstrumentals": "伴奏を除去",
  "train.info.removeInstrumentalsSub":
    "データセットからボーカル以外の音を取り除きます。",
  "train.info.removeReverb": "リバーブを除去",
  "train.info.removeReverbSub":
    "データセット内の音声からリバーブを取り除きます。",
  "train.info.cardTitle": "トレーニングの準備完了",
  "train.info.usuallyReadyIn": "完成までの目安",
  "train.info.upTo2h": "最大2時間",
  "train.info.closePage":
    "トレーニングはサーバー側で行われるので、ページを閉じても大丈夫です。",
  "train.info.starting": "開始中...",
  "train.info.start": "トレーニングを開始",
  "train.info.orGetPass": "またはトレーニングパスを購入",
  "train.info.getMorePasses": "トレーニングパスを追加購入",
  "train.info.usesOnePass": "トレーニングパスを1つ使用",
  "train.info.started": "トレーニングを開始しました",
  "train.info.onCreator": "Creatorプランです。トレーニングを開始しています...",
  "train.info.legal":
    "続行することで、アップロードしたコンテンツを使用する権利をJammableに付与し、「このコンテンツがあなた自身のものであり、第三者の著作物を含まないこと」を確認したものとみなされます。",
  "train.info.agreeTerms": "利用規約に同意してください！",
  "train.info.chooseName": "ボイス名を入力してください！",
  "train.info.uploadImage": "画像をアップロードしてください！",
  "train.info.invalidName": "無効なモデル名です。特殊文字は使えません",
  "train.info.signIn": "ログインが必要です",
  "train.info.errorStarting": "トレーニングの開始中にエラーが発生しました",
  "train.info.errorSignedUrl": "署名付きURLの取得中にエラーが発生しました",

  // Demo under step 1 (components/CustomModelDemo)
  "train.demo.title": "トレーニングしたボイスを聴く",
  "train.demo.by": "Jammableのパワーユーザー作",
  "train.demo.data.label": "トレーニングデータ",
  "train.demo.data.note": "数分間の声",
  "train.demo.input.label": "入力曲",
  "train.demo.input.note": "ボイスに歌わせる曲",
  "train.demo.output.label": "完成版",
  "train.demo.output.note": "トレーニングしたボイスで歌唱",
  "train.demo.play": "{label}を再生",
  "train.demo.pause": "{label}を一時停止",

  // Failed voice card (RetryTraining). The refuse.* lines mirror the
  // messages in lib/train/retry.ts, which the API sends in English.
  "train.retry.trainAgain": "もう一度トレーニング",
  "train.retry.tryAgain": "再試行",
  "train.retry.orNewSamples": "または新しいサンプルでトレーニング",
  "train.retry.retrying":
    "再トレーニング中です。完成したらメールでお知らせします。",
  "train.retry.couldntStart":
    "トレーニングを開始できませんでした。もう一度お試しください。",
  "train.retry.confirmUnlimited":
    "同じサンプルでもう一度トレーニングします。プランに含まれています。",
  "train.retry.confirmOutCreator":
    "再試行にはトレーニングパスが必要ですが、残りがありません。トレーニングはCreatorプランに含まれます。",
  "train.retry.confirmOut":
    "再試行にはトレーニングパスが必要ですが、残りがありません。",
  "train.retry.confirmPass":
    "同じサンプルでもう一度トレーニングします。トレーニングパスを1つ使用します（残り{passes}）。再び失敗した場合はパスが戻ります。",
  "train.retry.cancel": "キャンセル",
  "train.retry.seeCreator": "Creatorを見る",
  "train.retry.getPass": "トレーニングパスを購入",
  "train.retry.orGetPass": "またはトレーニングパスを購入",
  "train.retry.starting": "開始中...",
  "train.retry.usePass": "パスを使って再試行",
  "train.retry.refuse.cleanVocals":
    "再試行しても同じ理由で失敗します。音楽や長い無音のない、クリアなボーカルでトレーニングし直してください。",
  "train.retry.refuse.formats":
    "再試行しても同じ理由で失敗します。クリアな歌声や話し声のMP3、WAV、M4Aファイルでトレーニングし直してください。",
  "train.retry.refuse.newSamples":
    "再試行しても同じ理由で失敗します。新しいサンプルでトレーニングし直してください。",
  "train.retry.refuse.saveAs":
    "再試行しても同じ理由で失敗します。MP3かWAVで保存してから、トレーニングし直してください。",
  "train.retry.refuse.filesMissing":
    "新しいサンプルでトレーニングし直してください。",
  "train.retry.refuse.retryCap":
    "このボイスは{n}回試行されています。できれば別のサンプルで、トレーニングし直してください。",

  // TrainFinalStage (not currently rendered)
  "train.final.confirm": "確認",
  "train.final.back": "戻る",
  "train.final.next": "次へ",
};

export default train;
